export enum PurseType {
    XAF = 'XAF',
    TND = 'TND',
    ZWL = 'ZWL',
    TWD = 'TWD',
    TW13 = 'TW13',
    GMS = 'GMS',
    INR = 'INR',
    BTC = 'BTC',
    USD = 'USD',
    EUR = 'EUR',
    ETC = 'ETC',
    UAH = 'UAH',
    RUB = 'RUB',
    LTC = 'LTC',
    DEMO = 'DEMO',
    ETH = 'ETH',
    BRL = 'BRL',
    BCH = 'BCH',
    BNB = 'BNB',
    DASH = 'DASH',
    DOGE = 'DOGE',
    TRX = 'TRX',
    USDT = 'USDT',
    XMR = 'XMR',
    ZEC = 'ZEC',
    XRP = 'XRP',
    KZT = 'KZT',
    VND = 'VND',
    VND1 = 'VND1',
    UZS = 'UZS',
    IDR = 'IDR',
    IDR1 = 'IDR1',
    AZN = 'AZN',
    KGS = 'KGS',
    PKR = 'PKR',
    BDT = 'BDT',
    CLP = 'CLP',
    PEN = 'PEN',
    COP = 'COP',
    MXN = 'MXN',
    ARS = 'ARS',
    BOB = 'BOB',
    CRC = 'CRC',
    SVC = 'SVC',
    GTQ = 'GTQ',
    NIO = 'NIO',
    PAB = 'PAB',
    PYG = 'PYG',
    UYU = 'UYU',
    CAD = 'CAD',
    CZK = 'CZK',
    ZAR = 'ZAR',
    BGN = 'BGN',
    DKK = 'DKK',
    RON = 'RON',
    AUD = 'AUD',
    NZD = 'NZD',
    CHF = 'CHF',
    NOK = 'NOK',
    HUF = 'HUF',
    TRY = 'TRY',
    PLN = 'PLN',
    GBP = 'GBP',
    NGN = 'NGN',
    SEK = 'SEK',
    JPY = 'JPY',
    ZMW = 'ZMW',
    TZS = 'TZS',
    GHS = 'GHS',
    XOF = 'XOF',
    VEF = 'VEF',
    VES = 'VES',
    SGD = 'SGD',
    HRK = 'HRK',
    KRW = 'KRW',
    BUSD = 'BUSD',
    CSC = 'CSC',
    KES = 'KES',
    BAM = 'BAM',
    RSD = 'RSD',
    AED = 'AED',
    AFN = 'AFN',
    ALL = 'ALL',
    AMD = 'AMD',
    ANG = 'ANG',
    AOA = 'AOA',
    AWG = 'AWG',
    BBD = 'BBD',
    BHD = 'BHD',
    BIF = 'BIF',
    BMD = 'BMD',
    BND = 'BND',
    BOV = 'BOV',
    BSD = 'BSD',
    BTN = 'BTN',
    BWP = 'BWP',
    BYN = 'BYN',
    BZD = 'BZD',
    CDF = 'CDF',
    CHW = 'CHW',
    CLF = 'CLF',
    CUP = 'CUP',
    CVE = 'CVE',
    DJF = 'DJF',
    DOP = 'DOP',
    DZD = 'DZD',
    EGP = 'EGP',
    ERN = 'ERN',
    ETB = 'ETB',
    FJD = 'FJD',
    FKP = 'FKP',
    GEL = 'GEL',
    GMD = 'GMD',
    GNF = 'GNF',
    GYD = 'GYD',
    HKD = 'HKD',
    HNL = 'HNL',
    HTG = 'HTG',
    ILS = 'ILS',
    IQD = 'IQD',
    IRR = 'IRR',
    IRT = 'IRT',
    ISK = 'ISK',
    JMD = 'JMD',
    JOD = 'JOD',
    KHR = 'KHR',
    KMF = 'KMF',
    KPW = 'KPW',
    KWD = 'KWD',
    KYD = 'KYD',
    LAK = 'LAK',
    LBP = 'LBP',
    LKR = 'LKR',
    LRD = 'LRD',
    LSL = 'LSL',
    LYD = 'LYD',
    MAD = 'MAD',
    MDL = 'MDL',
    MGA = 'MGA',
    MKD = 'MKD',
    MMK = 'MMK',
    MNT = 'MNT',
    MOP = 'MOP',
    MRU = 'MRU',
    MUR = 'MUR',
    MVR = 'MVR',
    MWK = 'MWK',
    MYR = 'MYR',
    MZN = 'MZN',
    NAD = 'NAD',
    NPR = 'NPR',
    OMR = 'OMR',
    PGK = 'PGK',
    PHP = 'PHP',
    QAR = 'QAR',
    CNY = 'CNY',
    RWF = 'RWF',
    SAR = 'SAR',
    SBD = 'SBD',
    SCR = 'SCR',
    SDG = 'SDG',
    SHP = 'SHP',
    SLE = 'SLE',
    SLL = 'SLL',
    SOS = 'SOS',
    SRD = 'SRD',
    SSP = 'SSP',
    SYP = 'SYP',
    SZL = 'SZL',
    GIP = 'GIP',
    UGX = 'UGX',
    uBTC = 'uBTC',
    THB = 'THB',
    R$ = 'R$',
    DLS = 'DLS',
}
